import { useLayoutEffect } from "react";
import {
  ListIllustration,
  SomethingwentwrongIllustration,
} from "vega-illustrations";

import { EmptyCard } from "@vega-core/components/Cards/EmptyCard/EmptyCard";
import { Spinner } from "@vega-core/components/Loaders/LoadingSpinner/Spinner";
import { GroupedHeaderComparisonTable } from "@vega-core/components/Table/GroupedHeaderComparisonTable/GroupedHeaderComparisonTable";
import { m } from "@vega-core/paraglide/messages";

import { useModalSizeContext } from "../context";

import { usePermissionsTableColumns } from "./usePermissionsTableColumns";

export const PermissionsTable = () => {
  const { setWide } = useModalSizeContext();
  const { permissionRows, groupedHeaders, columns, isLoading, isError } =
    usePermissionsTableColumns();

  useLayoutEffect(
    function enlargeModal() {
      setWide(true);

      return () => setWide(false);
    },
    [setWide],
  );

  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <Spinner className="w-8 h-8" />
      </div>
    );
  }

  if (isError || permissionRows.length === 0) {
    return (
      <EmptyCard
        {...(isError
          ? {
              description: m.common_error_pleaseTryAgainLater(),
              illustration: <SomethingwentwrongIllustration />,
              title: m.common_error_somethingWentWrong(),
            }
          : {
              illustration: <ListIllustration />,
              title: m.common_noDataAvailable(),
            })}
      />
    );
  }

  return (
    <GroupedHeaderComparisonTable
      columns={columns}
      data={permissionRows}
      groupedHeaders={groupedHeaders}
    />
  );
};
